<template lang="pug">
  .product
    .container
      .row
        .col-xs-offset-2.col-xs-8.col-lg-offset-1.col-lg-3.col-xl-offset-1.col-xl-3
          picture.product__image-container
            source(:srcset="require(`@/assets/items/${item.fullImage}`)" media="(min-width: 2300px)")
            img.product__image(:src="require(`@/assets/items/${item.image}`)", :alt="item.title", :class="{'hide' : isPopupOpen}")
        .col-xs-12.col-lg-7
          .product__info
            h4.product__title(:class="{ 'product__title--default' : !item.isHighlighted }") 
              .product__title-inner(:class="{'hide' : isPopupOpen}") {{ item.title }}
            .product__details
              .product__subtitle(:class="{ 'product__subtitle--default' : !item.isHighlighted }") {{ item.subtitle }}
              p.product__description {{ item.description }}
              .product__specifications
                p.product__spec.spec
                  span.spec__name Вкус:
                  span.spec__value {{ item.taste }}
                p.product__spec.spec
                  span.spec__name Еда:
                  span.spec__value {{ item.food }}
                p.product__spec.spec
                  span.spec__name Охладить:
                  span.spec__value {{ item.temperature }}
                p.product__spec.spec
                  span.spec__name Пить:
                  span.spec__value {{ item.instruction }}
                p.product__spec.spec
                  span.spec__name Крепость:
                  span.spec__value {{ item.strength }}
</template>

<script>
export default {
  name: "FullItem",
  components: {},
  props: {
    item: {
      type: Object,
      required: true
    },
    isPopupOpen: {
      type: Boolean,
      required: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const hideNodes = document.querySelectorAll(".hide");

        for (let i = 0; i < hideNodes.length; i++) {
          const hideNode = hideNodes[i];
          hideNode.classList.remove("hide");
        }
      }, 200);
    });
  }
};
</script>

<style lang="scss">
@import "../styles/main.scss";

.hide {
  opacity: 0;
}

.product {
  &__image-container {
    margin: 5% auto 0;
    display: block;
    text-align: center;

    @include from("lg") {
      height: 92vh;
      margin: 10% auto 0;
      width: auto;
    }
  }
  &__image {
    width: auto;
    max-height: 450px;
    position: relative;
    transform-origin: left top;

    @include from("lg") {
      max-height: none;
      height: 100%;
      width: auto;
    }
  }
  &__info {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    width: 77%;
    margin: auto;

    @include from("xl") {
      margin: 0;
      margin-left: 5%;
      width: 100%;
    }

    @include from("xxl") {
      margin-left: 10%;
    }
  }
  &__title {
    font-family: $font-mojito;
    color: $color-text--contrast;
    font-weight: normal;
    font-size: 70px;
    margin: 10% 0 10%;
    line-height: 0.8;
    text-align: center;

    &--default {
      margin-bottom: 20px;
      margin-top: 10%;
    }

    @include from("lg") {
      font-size: 150px;
      transform: translate(-20%, -10%);

      &--default {
        font-size: 120px;
        margin-bottom: 0;
      }
    }
    @include from("xl") {
      max-width: 80%;
      &--default {
        font-size: 125px;
        margin-bottom: 20px;
      }
    }
    @include from("xxl") {
      font-size: 175px;

      margin-top: 15%;
      margin-bottom: 60px;

      &--default {
        margin-bottom: 40px;
        font-size: 136px;
      }
    }
    @include from("xxxl") {
      width: 60%;
      margin: 15% 0 10%;
      font-size: 295px;

      &--default {
        font-size: 215px;
        margin: 15% 0 5%;
      }
    }
  }
  &__title-inner {
    display: inline-block;
    width: min-content;
    position: relative;
    transform-origin: left top;
  }
  &__subtitle {
    line-height: 1.1;
    color: $color-text--contrast;
    font-size: 24px;

    @include from("lg") {
      font-size: 30px;
    }
    @include from("xl") {
      font-size: 42px;
    }
    @include from("xxl") {
      font-size: 44px;
    }
    @include from("xxxl") {
      font-size: 70px;
      width: 70%;
    }
  }

  &__details {
    padding-bottom: 40px;

    @include from("xl") {
      margin-top: -5%;
    }
  }
  &__description {
    font-size: 16px;
    line-height: 1.2;

    @include from("xl") {
      font-size: 18px;
      margin-right: 15%;
    }
    @include from("xxl") {
      font-size: 24px;
    }
    @include from("xxxl") {
      margin: 3% 7% 3% 0;
      font-size: 30px;
    }
  }
}

.spec {
  margin: 0 0 5px;
  font-size: 16px;
  line-height: 1.2;

  @include from("xl") {
    font-size: 18px;
  }
  @include from("xxl") {
    font-size: 24px;
  }
  @include from("xxxl") {
    font-size: 30px;
  }
  &__name {
    font-weight: bold;
    margin-right: 10px;
  }
}
</style>